import React, { useMemo } from "react";
import { ImPlay2 } from "react-icons/im";
import { BsFillPlusCircleFill } from "react-icons/bs";
import Popup from "reactjs-popup";
import PropertyDetails from "./Popups/PropertyDetails";
import OXCancel from "./OXCancel";
import _ from "lodash";

const ContentDetails = ({ contents }) => {
  const photos = useMemo(() => {
    return _(contents)
      .flatMap("media")
      .value()
      .filter((media) => media.includes(".jpg") || media.includes(".png") || media.includes(".jpeg"));
  }, [contents]);

  const videos = useMemo(() => {
    const media = _(contents).flatMap("media").value();
    return _.differenceWith(media, photos, _.isEqual);
  }, [contents, photos]);

  return (
    <div>
      <div className="pb-5">
        <div className="flex items-center pb-5">
          <p className="text-2xl font-bold">Pictures</p>
          <div className="pl-5">
            <BsFillPlusCircleFill className="text-2xl text-primary cursor-pointer" />
          </div>
        </div>

        {photos.length > 0 ? (
          <div className="flex items-start gap-5">
            {photos?.map((url, index) => (
              <div key={index}>
                <Popup
                  trigger={
                    <div>
                      <img src={url} alt="" className="rounded-lg h-[169px] w-[169px] object-cover" />
                      <p className="font-semibold text-sm pt-1 "></p>
                    </div>
                  }
                  position="right center"
                  modal
                  nested
                  contentStyle={{
                    borderRadius: "12px",
                    backgroundColor: "white",
                    width: "fit-content",
                    fontSize: "0.8rem",
                    maxHeight: "98%",
                    overflow: "auto",
                  }}
                >
                  {(close) => (
                    <>
                      <OXCancel close={close} />
                      <PropertyDetails close={close} url={url} />
                    </>
                  )}
                </Popup>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-red-700 text-[14px]">No photo available</p>
        )}
      </div>
      <div>
        <div className="flex items-center pb-5">
          <p className="text-2xl font-bold">Videos</p>
          <div className="pl-5">
            <BsFillPlusCircleFill className="text-2xl text-primary cursor-pointer" />
          </div>
        </div>
        {videos.length > 0 ? (
          <div className="flex items-start gap-5">
            {videos.map((video, index) => (
              <div key={index}>
                <Popup
                  trigger={
                    <div>
                      <div className="relative w-[169px] block h-[169px] rounded-lg overflow-hidden" key={index}>
                        <video
                          style={{ height: "100%", width: "100%", margin: "auto", display: "block" }}
                          controls
                          className="mx-auto object-contain"
                        >
                          <source src={video} alt="" />
                        </video>
                        <div className="absolute top-0 bg-black bg-opacity-30 rounded-lg h-full w-full">
                          <div className="flex justify-center pt-14">
                            <ImPlay2 className="text-4xl text-white cursor-pointer" />
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  position="right center"
                  modal
                  nested
                  contentStyle={{
                    borderRadius: "12px",
                    backgroundColor: "white",
                    width: "fit-content",
                    fontSize: "0.8rem",
                    maxHeight: "98%",
                    overflow: "auto",
                  }}
                >
                  {(close) => (
                    <>
                      <OXCancel close={close} />
                      <PropertyDetails close={close} url={video} video />
                    </>
                  )}
                </Popup>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-red-700 text-[14px]">No video available</p>
        )}
      </div>
    </div>
  );
};

export default ContentDetails;
